<script setup lang="ts">
import UploadFileWithDownloadableFileList from '@/components/upload/UploadFileWithDownloadableFileList.vue';
import InputTextGroup from '@/components/forms/groups/InputTextGroup.vue';

// -----
// Types
// -----

interface Props {
  uploadFilters?: Record<string, any>;
  displayFilters?: Record<string, any>;
  files?: any[];
  fileRemove?: (id: string) => void;
  hiddenInputLabel?: string;
}

// -----
// Props
// -----

const props = withDefaults(defineProps<Props>(), {
  uploadFilters: () => ({}),
  displayFilters: () => ({}),
  files: () => [],
  fileRemove: () => {},
  hiddenInputLabel: '',
});
</script>

<template>
  <div :class="$style['upload-block']">
    <h3 v-if="$slots.title" :class="$style['upload-block__heading']">
      <slot name="title" />
    </h3>
    <p v-if="$slots.description" :class="$style['upload-block__description']">
      <span :class="$style['upload-block__description__icon']">
        <icon name="info-circle" />
      </span>
      <span :class="$style['upload-block__description__text']">
        <slot name="description" />
      </span>
    </p>
    <UploadFileWithDownloadableFileList
      :class="$style['upload-block__upload-file-list']"
      ref="upload-file-with-downloadable-file-list"
      :upload-filters="props.uploadFilters"
      :display-filters="props.displayFilters"
      empty-prompt="Drag & drop files here or browse"
      theme="onboarding"
      no-list
      :files="props.files"
      @fileRemove="props.fileRemove"
    />
    <InputTextGroup
      v-if="props.hiddenInputLabel"
      :name="props.hiddenInputLabel"
      label=""
      :style="{ display: 'none' }"
    />
  </div>
</template>

<style module lang="less">
.upload-block {
  display: flex;
  flex-direction: column;
}

h3.upload-block__heading {
  color: var(--neutral-grey-400, #5f5f61);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin: 0 0 4px 0;
}

p.upload-block__description {
  color: var(--neutral-grey-500, #303032);
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px;
  margin: 0 0 20px 0;
  display: flex;
  gap: 8px;
}

p.upload-block__description a {
  color: var(--primary-blue-500, #007bff);
  text-decoration: underline;
}

.upload-block__upload-file-list [class*='upload-zone'] {
  margin-bottom: 0;
}
</style>
